// source: witbooking/backoffice/orchestrator/common/v1/orchestration_criteria.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var witbooking_backoffice_common_common_pb = require('../../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.DeviceType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.MatchMode', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.ConditionCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.SeasonType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.displayName = 'proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchMode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    conditionsList: jspb.Message.toObjectList(msg.getConditionsList(),
    proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria;
  return proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.common.v1.MatchMode} */ (reader.readEnum());
      msg.setMatchMode(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.deserializeBinaryFromReader);
      msg.addConditions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getConditionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional MatchMode match_mode = 1;
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.MatchMode}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.getMatchMode = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.common.v1.MatchMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.MatchMode} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.setMatchMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated OrchestrationCondition conditions = 2;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.getConditionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.setConditionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.addConditions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria.prototype.clearConditionsList = function() {
  return this.setConditionsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.ConditionCase = {
  CONDITION_NOT_SET: 0,
  OCCUPANCY: 1,
  CHECK_IN_DAY: 2,
  CHECK_OUT_DAY: 3,
  LENGTH_OF_STAY: 4,
  BOOKING_WINDOW: 5,
  TRAVEL_WINDOW: 6,
  NUMBER_OF_ROOMS: 7,
  DEVICE: 8,
  REFERRER: 9,
  UTM_SOURCE: 10,
  ORIGIN: 11,
  SEASON: 12
};

/**
 * @return {proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.ConditionCase}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getConditionCase = function() {
  return /** @type {proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupancy: (f = msg.getOccupancy()) && proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.toObject(includeInstance, f),
    checkInDay: (f = msg.getCheckInDay()) && proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.toObject(includeInstance, f),
    checkOutDay: (f = msg.getCheckOutDay()) && proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.toObject(includeInstance, f),
    lengthOfStay: (f = msg.getLengthOfStay()) && proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.toObject(includeInstance, f),
    bookingWindow: (f = msg.getBookingWindow()) && proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.toObject(includeInstance, f),
    travelWindow: (f = msg.getTravelWindow()) && proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.toObject(includeInstance, f),
    numberOfRooms: (f = msg.getNumberOfRooms()) && proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.toObject(includeInstance, f),
    device: (f = msg.getDevice()) && proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.toObject(includeInstance, f),
    referrer: (f = msg.getReferrer()) && proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.toObject(includeInstance, f),
    utmSource: (f = msg.getUtmSource()) && proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.toObject(includeInstance, f),
    origin: (f = msg.getOrigin()) && proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.toObject(includeInstance, f),
    season: (f = msg.getSeason()) && proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.deserializeBinaryFromReader);
      msg.setOccupancy(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.deserializeBinaryFromReader);
      msg.setCheckInDay(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.deserializeBinaryFromReader);
      msg.setCheckOutDay(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.deserializeBinaryFromReader);
      msg.setLengthOfStay(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.deserializeBinaryFromReader);
      msg.setBookingWindow(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.deserializeBinaryFromReader);
      msg.setTravelWindow(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.deserializeBinaryFromReader);
      msg.setNumberOfRooms(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.deserializeBinaryFromReader);
      msg.setReferrer(value);
      break;
    case 10:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.deserializeBinaryFromReader);
      msg.setUtmSource(value);
      break;
    case 11:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.deserializeBinaryFromReader);
      msg.setOrigin(value);
      break;
    case 12:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.deserializeBinaryFromReader);
      msg.setSeason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupancy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.serializeBinaryToWriter
    );
  }
  f = message.getCheckInDay();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.serializeBinaryToWriter
    );
  }
  f = message.getCheckOutDay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.serializeBinaryToWriter
    );
  }
  f = message.getLengthOfStay();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.serializeBinaryToWriter
    );
  }
  f = message.getBookingWindow();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.serializeBinaryToWriter
    );
  }
  f = message.getTravelWindow();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfRooms();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.serializeBinaryToWriter
    );
  }
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.serializeBinaryToWriter
    );
  }
  f = message.getReferrer();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.serializeBinaryToWriter
    );
  }
  f = message.getUtmSource();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.serializeBinaryToWriter
    );
  }
  f = message.getOrigin();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.serializeBinaryToWriter
    );
  }
  f = message.getSeason();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional OccupancyCondition occupancy = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getOccupancy = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setOccupancy = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearOccupancy = function() {
  return this.setOccupancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasOccupancy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CheckInDayCondition check_in_day = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getCheckInDay = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setCheckInDay = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearCheckInDay = function() {
  return this.setCheckInDay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasCheckInDay = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CheckOutDayCondition check_out_day = 3;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getCheckOutDay = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition, 3));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setCheckOutDay = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearCheckOutDay = function() {
  return this.setCheckOutDay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasCheckOutDay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LengthOfStayCondition length_of_stay = 4;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getLengthOfStay = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition, 4));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setLengthOfStay = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearLengthOfStay = function() {
  return this.setLengthOfStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasLengthOfStay = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BookingWindowConditions booking_window = 5;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getBookingWindow = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions, 5));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setBookingWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearBookingWindow = function() {
  return this.setBookingWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasBookingWindow = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TravelWindowConditions travel_window = 6;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getTravelWindow = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions, 6));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setTravelWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearTravelWindow = function() {
  return this.setTravelWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasTravelWindow = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NumberOfRoomsCondition number_of_rooms = 7;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getNumberOfRooms = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition, 7));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setNumberOfRooms = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearNumberOfRooms = function() {
  return this.setNumberOfRooms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasNumberOfRooms = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional DeviceCondition device = 8;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getDevice = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition, 8));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setDevice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ReferrerCondition referrer = 9;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getReferrer = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition, 9));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setReferrer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearReferrer = function() {
  return this.setReferrer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasReferrer = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional UtmSourceCondition utm_source = 10;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getUtmSource = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition, 10));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setUtmSource = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearUtmSource = function() {
  return this.setUtmSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasUtmSource = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OriginCondition origin = 11;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getOrigin = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition, 11));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setOrigin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearOrigin = function() {
  return this.setOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasOrigin = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional SeasonCondition season = 12;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.getSeason = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition, 12));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.setSeason = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.clearSeason = function() {
  return this.setSeason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCondition.prototype.hasSeason = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OccupancyCondition.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    activeDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setActiveDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek active_days = 3;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.getActiveDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.setActiveDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.addActiveDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckInDayCondition.prototype.clearActiveDaysList = function() {
  return this.setActiveDaysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    activeDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setActiveDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek active_days = 3;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.getActiveDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.setActiveDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.addActiveDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.CheckOutDayCondition.prototype.clearActiveDaysList = function() {
  return this.setActiveDaysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: jspb.Message.getFieldWithDefault(msg, 1, 0),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMin(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 min = 1;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.getMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.setMin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value max = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.LengthOfStayCondition.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    activeDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    startHour: jspb.Message.getFieldWithDefault(msg, 4, ""),
    endHour: jspb.Message.getFieldWithDefault(msg, 5, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setActiveDaysList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartHour(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndHour(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActiveDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getStartHour();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEndHour();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek active_days = 3;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getActiveDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setActiveDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.addActiveDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.clearActiveDaysList = function() {
  return this.setActiveDaysList([]);
};


/**
 * optional string start_hour = 4;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getStartHour = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setStartHour = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string end_hour = 5;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getEndHour = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setEndHour = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string time_zone = 6;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.toObject = function(includeInstance, msg) {
  var f, obj = {
    windowsList: jspb.Message.toObjectList(msg.getWindowsList(),
    proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions;
  return proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.deserializeBinaryFromReader);
      msg.addWindows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWindowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BookingWindowCondition windows = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.getWindowsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.setWindowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.addWindows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowCondition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.BookingWindowConditions.prototype.clearWindowsList = function() {
  return this.setWindowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    activeDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setActiveDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActiveDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek active_days = 3;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.getActiveDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.setActiveDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.addActiveDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.prototype.clearActiveDaysList = function() {
  return this.setActiveDaysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.toObject = function(includeInstance, msg) {
  var f, obj = {
    windowsList: jspb.Message.toObjectList(msg.getWindowsList(),
    proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions;
  return proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.deserializeBinaryFromReader);
      msg.addWindows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWindowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TravelWindowCondition windows = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.getWindowsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.setWindowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.addWindows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowCondition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.TravelWindowConditions.prototype.clearWindowsList = function() {
  return this.setWindowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: jspb.Message.getFieldWithDefault(msg, 1, 0),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMin(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 min = 1;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.getMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.setMin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value max = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} returns this
*/
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.common.v1.NumberOfRoomsCondition.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    typesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.DeviceType>} */ (reader.readPackedEnum());
      msg.setTypesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated DeviceType types = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.DeviceType>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.DeviceType>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.DeviceType>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceType} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceCondition.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.ReferrerCondition.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.UtmSourceCondition.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.OriginCondition.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    seasonsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    hemisphere: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition;
  return proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.SeasonType>} */ (reader.readPackedEnum());
      msg.setSeasonsList(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere} */ (reader.readEnum());
      msg.setHemisphere(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeasonsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getHemisphere();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated SeasonType seasons = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.SeasonType>}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.getSeasonsList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.SeasonType>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.common.v1.SeasonType>} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.setSeasonsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonType} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.addSeasons = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.clearSeasonsList = function() {
  return this.setSeasonsList([]);
};


/**
 * optional Hemisphere hemisphere = 2;
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.getHemisphere = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere} value
 * @return {!proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition} returns this
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonCondition.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.MatchMode = {
  MATCH_MODE_UNSPECIFIED: 0,
  ALL: 1,
  ANY: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.DeviceType = {
  DEVICE_TYPE_UNSPECIFIED: 0,
  DEVICE_TYPE_DESKTOP: 1,
  DEVICE_TYPE_MOBILE: 2,
  DEVICE_TYPE_TABLET: 3
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.SeasonType = {
  SEASON_TYPE_UNSPECIFIED: 0,
  SPRING: 1,
  SUMMER: 2,
  AUTUMN: 3,
  WINTER: 4
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.common.v1.Hemisphere = {
  HEMISPHERE_UNSPECIFIED: 0,
  NORTHERN: 1,
  SOUTHERN: 2
};

goog.object.extend(exports, proto.witbooking.backoffice.orchestrator.common.v1);
